import { Validators } from '@angular/forms';
import { isEmpty, sortBy } from 'lodash';
var DialogSegmentsMapper = /** @class */ (function () {
    function DialogSegmentsMapper() {
    }
    DialogSegmentsMapper.toGeneralForm = function (segment, formBuilder) {
        return formBuilder.group({
            name: [segment.name || null, [Validators.required]]
        });
    };
    DialogSegmentsMapper.toMaintenanceTypesForm = function (segment, formBuilder) {
        return formBuilder.group({
            maintenanceTypes: formBuilder.control(!isEmpty(segment.maintenanceTypes) ? segment.maintenanceTypes : null)
        });
    };
    DialogSegmentsMapper.toSegmentMaintenanceFormsArray = function (segment, formBuilder) {
        var segmentMaintenanceTypeForms = segment.segmentMaintenanceTypeForms || [];
        var segmentMaintenanceTypeFormsSorted = sortBy(segmentMaintenanceTypeForms, 'form.name');
        return formBuilder.array(segmentMaintenanceTypeFormsSorted.map(function (segmentMaintenanceTypeForm) {
            return formBuilder.group({
                form: formBuilder.control(segmentMaintenanceTypeForm.form || null, [Validators.required]),
                requiredComplete: formBuilder.control(segmentMaintenanceTypeForm.requiredComplete || false),
                requiredReport: formBuilder.control(segmentMaintenanceTypeForm.requiredReport || false),
                requiredStart: formBuilder.control(segmentMaintenanceTypeForm.requiredStart || false),
                maintenanceType: formBuilder.control({
                    id: segmentMaintenanceTypeForm.maintenanceType ? segmentMaintenanceTypeForm.maintenanceType.id : null,
                    name: segmentMaintenanceTypeForm.maintenanceType ? segmentMaintenanceTypeForm.maintenanceType.name : null,
                    isAllSelected: Boolean(segment.id && !segmentMaintenanceTypeForm.maintenanceType)
                }, [Validators.required]),
            });
        }));
    };
    DialogSegmentsMapper.toSaveSegmentInput = function (_a) {
        var segment = _a.segment, segmentsIds = _a.segmentsIds, generalForm = _a.generalForm, settingsTab = _a.settingsTab, maintenanceTypesForm = _a.maintenanceTypesForm, segmentMaintenanceFormsArray = _a.segmentMaintenanceFormsArray;
        return {
            segmentsIds: segmentsIds,
            archived: segment.archived,
            name: generalForm.value.name,
            maintenanceTypeIds: this.toSegmentMaintenanceTypesInput({ settingsTab: settingsTab, maintenanceTypesForm: maintenanceTypesForm }),
            segmentMaintenanceTypeForms: segmentMaintenanceFormsArray.value.map(function (form) { return ({
                formId: form.form.id,
                requiredStart: form.requiredStart,
                requiredReport: form.requiredReport,
                requiredComplete: form.requiredComplete,
                maintenanceTypeId: form.maintenanceType.isAllSelected ? null : form.maintenanceType.id,
            }); })
        };
    };
    DialogSegmentsMapper.toSegmentMaintenanceTypesInput = function (_a) {
        var settingsTab = _a.settingsTab, maintenanceTypesForm = _a.maintenanceTypesForm;
        if (!settingsTab.segmentsSettingsForm.get('linkMaintenanceTypesToSegment').value) {
            return [];
        }
        var maintenanceTypes = maintenanceTypesForm.get('maintenanceTypes').value;
        var mappedMaintenanceTypes = maintenanceTypes
            ? maintenanceTypes.map(function (maintenanceType) { return maintenanceType.id; })
            : [];
        return mappedMaintenanceTypes;
    };
    return DialogSegmentsMapper;
}());
export { DialogSegmentsMapper };
